<template>
  <div id="inspectOrder-edit">
    <IForm :label-width="75" ref="formInline" :model="edit" :elem="editElem" :rules="editRule" :submit="false">

      <div slot="extend">
        <Row>
          <Col span="12">
            <FormItem label="姓名" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入姓名" :disabled="readonly" maxlength="50"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="出生日期" prop="birthday"><Input v-model="edit.birthday" type="text" placeholder="请输入出生日期" :disabled="readonly"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="学校" prop="schoolName"><Input v-model="edit.schoolName" type="text" placeholder="请输入学校" :disabled="readonly"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="年级" prop="gradeName"><Input v-model="edit.gradeName" type="text" placeholder="请输入年级" :disabled="readonly"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="班级" prop="classesName"><Input v-model="edit.classesName" type="text" placeholder="请输入班级" :disabled="readonly"/></FormItem>
          </Col>
          <!--
          <Col span="12">
            <FormItem label="检验机构" prop="inspectOrganizeName"><Input v-model="edit.inspectOrganizeName" type="text" placeholder="请输入检验机构" :disabled="readonly"/></FormItem>
          </Col>
          -->
          <Col span="12">
            <FormItem label="手机号码" prop="phone"><Input v-model="edit.phone" type="text" placeholder="请输入手机号码" :disabled="readonly"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="条形码" prop="barCode"><Input v-model="edit.barCode" type="text" placeholder="请输入条形码" :disabled="readonly"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="状态" prop="inspectStatus">
              <Select v-model="edit.inspectStatus" style="width:100%;" :disabled="readonly">
                <Option v-for="item in enums.inspectStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="创建时间" prop="createTime"><Input v-model="edit.createTime" type="text" placeholder="请输入创建时间" :disabled="readonly"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="创建人" prop="operator"><Input v-model="edit.operator" type="text" placeholder="请输入操作人" :disabled="readonly"/></FormItem>
          </Col>
        </Row>

        <div style="font-size: 14px;margin-bottom: 10px; position: relative;display: flex;border-bottom: 1px solid #DCDFE6;">
          <div style="padding: 5px 16px 4px;border: 1px solid #dcdee2;border-bottom: 0;border-radius: 4px 4px 0 0;transition: all .3s ease-in-out;color: #2d8cf0;">LIS项目</div>
          <div style="padding: 5px 16px 4px;border: 1px solid #dcdee2;border-bottom: 0;border-radius: 4px 4px 0 0;transition: all .3s ease-in-out;color: #2d8cf0;position: absolute; right: 20%;">是否拉取</div>
        </div>

        <Row>
          <Col span="24">
            <FormItem :label-width="0" prop="fieldIds" style="max-height:250px;overflow-y:auto;text-align: left;">
              <el-tree ref="lisProjectTree" :data="edit.lisProjects" :props="defaultProps" node-key="id"
                       show-checkbox :check-strictly="true" :highlight-current="true" :expand-on-click-node="false" style="margin-left: 0px;">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <div class="custom-tree-node-content">{{ node.label }}
                    <span :style="{'color': convertBloodTube(data.bloodTubeId).color}" v-if="data.pid==0&&data.bloodTubeId">-{{data.bloodTubeName}}</span>
                    <span :style="{'margin-left':'30px','color': (data.checkStatus==1?'#CE1616':'#2d8cf0')}" v-if="edit.checkStatus>1">{{data.checkStatus==1?'未抽血':'已抽血'}}</span>
                    <span style="color:#CE1616;margin-left:30px;" v-if="data.checkStatus>1&&data.leaveStatus==2">请假</span>
                  </div>
                </span>
              </el-tree>
            </FormItem>
          </Col>
        </Row>

      </div>
    </IForm>

  </div>
</template>
<script>

import {_get} from "@/services/screening/inspectOrderPage.js";
import {enums} from "@/services/enums";
export default {
  name: "InspectOrderEdit",
  components: {},
  data() {
    return {
      edit: {
        physicalId:"",
        barCode:"",
        schoolId:"",
        schoolName:"",
        gradeId:"",
        gradeName:"",
        classesId:"",
        classesName:"",
        name:"",
        gender:"",
        idCard:"",
        birthday:"",
        inspectOrganizeId:"",
        inspectOrganizeName:"",
        checkStatus:"",
        inspectStatus:"",
        createTime:"",
        createUser:"",
        operator:"",
        lisProjects: [],
      },
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      readonly:true,
      enums: enums,
      init: "",
      editElem: [],
      editRule: {

      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
       this.handleEdit(row);
    },
    convertBloodTube(bloodTubeId){
      if(bloodTubeId == 1){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId == 2){
        return {color:'#16B94E',name:"绿管"};
      }else if(bloodTubeId == 3){
        return {color:'#540BA2',name:"紫管"}
      }else if(bloodTubeId == 4){
        return {color:'#006DFD',name:"蓝管"}
      }else if(bloodTubeId == 5){
        return {color:'#100F0FFF',name:"黑管"};
      }else if(bloodTubeId == 6){
        return {color:'#BDAE0C',name:"黄管"}
      }else if(bloodTubeId == 7){
        return {color:'#9BA0AB',name:"灰管"}
      }else if(bloodTubeId == 8){
        return {color:'#BF7007',name:"橙管"}
      }else if(bloodTubeId == 9){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId == 10){
        return {color:'#CE1616',name:"红管"};
      }
    },
    handleEdit(row) {
      _get({id: row.id}).then(res => {
        this.edit = Object.assign({}, res.data);
        let tempList = [];
        this.edit.lisProjects.forEach(item => {
          let children = [];
          if (item.children) {
            item.children.forEach(subItem => {
              children.push({
                id: subItem.lisProjectId,
                value:subItem.lisProjectId,
                label: subItem.lisProjectName,
                pid: subItem.parentId,
                disabled: true,
              })
            })
          }

          tempList.push({
            id: item.lisProjectId,
            value:item.lisProjectId,
            pid: item.parentId,
            label: item.lisProjectName,
            bloodTubeId: item.bloodTubeId,
            bloodTubeName: item.bloodTubeName,
            lisProjectCode: item.lisProjectCode,
            tubeStatus: item.tubeStatus,
            checkStatus: item.checkStatus,
            leaveStatus: item.leaveStatus,
            disabled: true,
            children: children,
          })
        });
        this.edit.lisProjects = tempList;
        this.$refs.lisProjectTree.setCheckedKeys(this.edit.lisProjectIds&&this.edit.lisProjectIds.length>0?this.edit.lisProjectIds:[]);
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
.el-divider--horizontal {display: block;height: 1px;width: 100%;margin: 24px 0;}
.el-divider {background-color: #DCDFE6;position: relative;}
/deep/ .el-tree-node .el-tree-node__content .el-checkbox {position: absolute !important;right: 20% !important;}
/deep/ .el-tree-node__content > label.el-checkbox {margin-right: 8px;}
/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {background-color: #409EFF;border-color: #409EFF;}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}
/deep/ .ivu-select-disabled .ivu-select-selection {background-color: #f3f3f38c;color: #515a6e;}


</style>
